// only run on applyjob
if($('#pagename').val() === 'applyjob'){


	var apply_step = 1;
	var godeepCategory = $('#godeep_cat').val();

	var allCountriesData = new Array();
	var request = $.ajax({
	   type: 'GET',
	   url:  canvas_url+'allstates/allcountries-final.json',
	   dataType: 'json'
	});

	request.done(function(data) {
		allCountriesData = data;
	});

	request.fail(function (jqXHR, textStatus) {
		console.log("Somethin wrong with all counries");
	});

	var client_platform_id = $("#engine-tech-issue-wrapper").attr('data-platform');
	if (typeof client_platform_id=='undefined' || client_platform_id==null || client_platform_id=='' || client_platform_id==0) client_platform_id = 1;

	var soundPath = canvas_url+"assets/sound/louis";
	var sound = new buzz.sound(soundPath, {
		formats: [ "ogg", "mp3", "aac" ]
	});

	/* <![CDATA[ */
	var google_conversion_id = 989880820;
	var google_conversion_language = "en";
	var google_conversion_format = "3";
	var google_conversion_color = "ffffff";
	var google_conversion_label = "HFJTCKmi818Q9MOB2AM";
	var google_remarketing_only = false;
	/* ]]> */

	function checkDistance()
	{
	}

	$(document).ready(function () {

		$('.combo-date-picker').combodate({
	        minYear: 1955,
	        smartDays: true,
	        maxYear: n,
	        firstItem: 'name',
	        customClass: 'form-control text-capitalize'
	    });

	    var next = new Date().getFullYear() + 3;
	    $('.is-date-picker').combodate({
	        minYear: (new Date().getFullYear()),
	        smartDays: true,
	        maxYear: next,
	        firstItem: 'name',
	        customClass: 'form-control text-capitalize'
	    });
	    $('#is_end_date').combodate({
	        minYear: (new Date().getFullYear()),
	        maxYear: next,
	        smartDays: true,
	        firstItem: 'name',
	        customClass: 'form-control text-capitalize'
	    });

		//translate cover letter from chinese
	    $('#cover_letter').blur(function () {
	        //call bing
	        if (
	                typeof azure_token !== 'undefined' && azure_token != ''
	                && $('#cover_letter').val().match(/[\u3400-\u9FBF]/) //unicode?
	                ) {
	            var from = "zh", to = "en", text = $('#cover_letter').val();
	            var azure_endpoint = "https://api.microsofttranslator.com/V2/Ajax.svc/Translate" +
	                    "?appId=Bearer " + encodeURIComponent(azure_token) +
	                    "&from=" + encodeURIComponent(from) +
	                    "&to=" + encodeURIComponent(to) +
	                    "&text=" + encodeURIComponent(text) +
	                    "&oncomplete=";
	            $.get(azure_endpoint, function (data) {
	                var error = data.match(/(TranslateApiException)+/gi);
	                if (!error) {
	                    $('#cover_letter_english').val(data);
	                    $('#cover_letter_english-parent').fadeIn('slow');
	                } else {
	                    //notify the geek group
	                    errorAlert({key: 'azure-translator', message: 'could not translate in job application form: azure is out of credits'});
	                }
	            }, "json");
	        } else {
	            $('#cover_letter_english-parent').fadeOut('slow', function () {
	                $('#cover_letter_english').val('');
	            });
	        }
	    });

		//Save
	    $(".save_job").bind("click", function () {
	        if (isLogin=='0') // User not login
	        {
	            trackEvent({event: 'click', key: 'Login for save job', value: 'Login for save job'});
	            showLoginModal(event);
	        }
	        else
	        {
	            var jid = $(this).attr("data-id");
	            if ($(".save_job").hasClass("disabled")) {
	                return false;
	            } else {
	                $.post(canvas_url + "api/job/saved", {'job_id': jid, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
	                    if (data.status == 'success') {
	                        $(".save_job").addClass("disabled");
	                        $(".save_job").addClass("savedjob");
	                        $(".save_job").html('<i class="fa fa-heart"></i> ' + txt_apply_saved + '');

	                        swal({
		                      title: txt_done_label,
		                      text: txt_job_saved_list,
		                      type: 'success',
		                      width: 450,
		                      confirmButtonText: 'Ok, Thanks',
		                      confirmButtonClass: 'btn btn-primary',
		                      buttonsStyling: false
		                    });

	                    } else {
	                        $(".save_job").addClass("disabled");
	                        notify(data.msg, "warning");
	                    }
	                }, "json");
	            }

	        }

	    });

		$(".inputtel").intlTelInput({
			separateDialCode : true,
		    initialCountry: "MY",
		    preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"],
		    onlyCountries: ["MY", "ID", "PH", "VN", "TH", "SG","CN", "IN", "PK", "BD"]
		});

		$("#add-reference-phone").intlTelInput("setNumber", "");

		$("input[name=first_time_working]:radio").change(function () {
			var first_time_working = $('input[name=first_time_working]:checked').val();

			$("#currently_working-div").addClass('hide');
			$("#currently_working_yes").addClass('hide');
			$("#currently_working_no").addClass('hide');

			if (first_time_working == 'No') {
				$("#currently_working-div").removeClass('hide');
			}
			else {
				$("#currently_working-div").addClass('hide');
				$('input[name=currently_working]:checked').attr("checked",false);
			}
	    });

		$("input[name=currently_working]:radio").change(function () {
			var currently_working = $('input[name=currently_working]:checked').val();

			if (currently_working == 'No') {
				$("#currently_working_no").removeClass('hide');
				$("#currently_working_yes").addClass('hide');
			}
			else {
				$("#currently_working_no").addClass('hide');
				$("#currently_working_yes").removeClass('hide');
			}
	    });

		$(".lang-option").bind("click", function () {
			var langoption = $(this).closest('.item').attr("id");
			var selectedoption = $(this).attr("data-value");
			$("#"+langoption+" .lang-option").each(function (index) {
				var v = $(this).attr('data-value');
				if (v==selectedoption)
				$(this).addClass('selected');
				else
				$(this).removeClass('selected');
			});

			$("#languages-div").removeClass('has-error');
			$("#lang-error").hide();
		});

		$("#base_country").change(function () {
			var value = $("#base_country").val();
			if (value=='Malaysian')
			{
				$("#ic-div").removeClass('hide');
				$("#passport-div").addClass('hide');
			}
			else
			{
				$("#ic-div").addClass('hide');
				$("#passport-div").removeClass('hide');
			}

			if (value=='' || value=='0')
			$("#after_nationality").addClass('hide');
			else
			$("#after_nationality").removeClass('hide');
		});

		$("#ic").bind("keyup", function (event) {
	    	var key = event.keyCode || event.charCode;
	    	if (key == 8 || key == 46 || key == 37 || key == 189)
	            return;
	   		 this.value = this.value.match(/\d*/g).join('').match(/(\d{0,6})(\d{0,2})(\d{0,4})/).slice(1).join('-').replace(/-*$/g, '');
	    });

		$("#ic").blur(function () {

			 // Set DOB and Gender according to IC
			 var ic_number = $(this).val();
			 var decade = $(this).val().substr(0, 2);
			 var dob_month = $(this).val().substr(2, 2);
			 var dob_day = $(this).val().substr(4, 2);
			 var milenium = ( decade < 50 ? 20 : 19 );
			 var dob_year = milenium+decade;
			 var finalDob = dob_day+'/'+dob_month+'/'+dob_year;
			 $('#dob').combodate('setValue', finalDob, true);

			 var genderCode = $(this).val().substr(ic_number.length -1);
			 genderCode = parseInt(genderCode);
			 if (genderCode%2===0) // Even - female
			 {
				 $("#genderF").attr("checked",true);
			 }
			 else
			 {
				 $("#genderM").attr("checked",true);
			 }
	    });

		$("#no_referral").change(function () {

			if($(this).prop('checked') == true){
				$('#referral-div').hide()
			}else{
				$('#referral-div').show()
			}
		});

		//hack for combodate validation only required when visible
		setTimeout(function(){
			if($('#internship-div').is(':visible')){
				$('#internship-div').find('input').addClass('important');
			}

			if($('#after_nationality').is(':visible')){
				$('#after_nationality').find('.combo-date-picker').addClass('important');
			}
		},500)


		//validate sign up form
		$("#signupForm").validate( {
			messages: {
				'base_country': txt_nl_choosenationaliy,
				'ic': txt_nl_entericnumber,
				'passport': txt_nl_enterpassport,
				'gender': txt_nl_selectgender,
				'dob': txt_nl_selectdob,
				'work_permit': txt_nl_selectworkpermit,
				'availability': txt_nl_choosestartworking,
				'fresh_graduate': txt_nl_choosefreshgraduate,
				'first_time_working': txt_nl_workingfirstime,
				'currently_working': txt_nl_currentlyworking,
				'ae_school_name': txt_nl_enterschool,
				'ae_degree': txt_nl_chooseeducation,
				'ae_major': txt_nl_entercourse,
				'current_company_name': txt_nl_currentcompany,
				'current_title': txt_nl_currentjobtitle,
				'previous_company_name': txt_nl_previouscompany,
				'previous_title': txt_nl_previousjobtitle,
				'address1': txt_nl_enteraddress,
				'city': txt_nl_entercity,
				'country': txt_nl_selectcountry,
				'new_state_id': txt_nl_selectstate,
				'email': txt_email_address_error,
			},
			submitHandler: function() {
				//alert('click to submit');
				go('.applyjob_next',100,0);
				$("#signupForm").validate().showErrors({
				  "next_step": 'Please click "Next" to proceed.'
				});

				return false;

			}
		});

		//apply job next  button
		$(".applyjob_next").bind('click', function () {

			if($( "#signupForm").valid() == true){
				$.submitApplyProfile();
			}else{
				$("#signupForm").validate().focusInvalid();;
			}
			return false;
		});



		$.submitApplyProfile = function()
		{
			var job_id 								= $("#job_id").val();
			var pagename 							= $("#pagename").val();
			var $btn 								= $(".applyjob_next");
			var job_filters 						= JSON.parse(jobfilters);
			var job_required_data 					= JSON.parse(jobrequireddata);
			var user_object_data					= JSON.parse(userobject);
			var job_data 							= JSON.parse(jobobject);
			var user_data							= user_object_data.user;

			var photo_filename 						= $("#photo_filename").val();
			var no_photo_checked 					= $("#no_photo").is(':checked');
			var no_photo							= 'no';
			if (no_photo_checked === true)
			{
				no_photo							= 'yes';
			}
			var name 								= $("#name").val();
			var email 								= $("#email").val();
			var phone 								= $("#phone").val();
			var selectedDialCode 					= $("#phone-div .selected-dial-code").html();
			phone									= cleanPhone(phone.replace(/[^0-9]/g, ''),'applyjob');

			if (selectedDialCode=='')
			selectedDialCode = '+60';

			var basicprofile_obj					= {};
			basicprofile_obj.base_country 			= $("#base_country").val();
			basicprofile_obj.ic 					= $("#ic").val();
			basicprofile_obj.passport 				= $("#passport").val();
			basicprofile_obj.gender 				= $('input[name=gender]:checked').val();
			basicprofile_obj.dob 					= $("#dob").val();
			basicprofile_obj.work_permit 			= $("#work_permit").val();
			basicprofile_obj.availability 			= $("#availability").val();


			var experience_obj 						= {};
			experience_obj.fresh_graduate			= $('input[name=fresh_graduate]:checked').val();
			experience_obj.first_time_working 		= $('input[name=first_time_working]:checked').val();
			experience_obj.currently_working 		= $('input[name=currently_working]:checked').val();
			experience_obj.current_company_name		= $("#current_company_name").val();
			experience_obj.current_title			= $("#current_title").val();
			experience_obj.current_salary_curr		= $("#current_salary_curr").val();
			experience_obj.current_salary			= $("#current_salary").val();
			experience_obj.current_description		= $("#current_description").val();
			experience_obj.previous_company_name	= $("#previous_company_name").val();
			experience_obj.previous_title		 	= $("#previous_title").val();
			experience_obj.previous_salary_curr 	= $("#previous_salary_curr").val();
			experience_obj.previous_salary		 	= $("#previous_salary").val();
			experience_obj.previous_description 	= $("#previous_description").val();
			experience_obj.exp_id 					= $("#exp_id").val();

			var location_obj 						= {};
			location_obj.willing_to_relocate		= $("#willing-to-relocate").val();
			location_obj.address1 					= $("#address1").val();
	        location_obj.city 						= $("#city").val();
	        location_obj.postal_code 				= $("#postal_code").val();
	        location_obj.country 					= $("#country").val();
			location_obj.state 						= $("#new_state_id").val();

			var education_obj 						= {};
			education_obj.currently_studing 		= $("#currently_studing").is(':checked');
			education_obj.ae_school_name 			= $("#ae_school_name").val();
			education_obj.ae_degree 				= $("#ae_degree").val();
			education_obj.aedu_start_date 			= $("#aedu_start_date").val();
			education_obj.aedu_end_date 			= $("#aedu_end_date").val();
			education_obj.ae_major 					= $("#ae_major").val();
			education_obj.edu_id 					= $("#edu_id").val();


			var reference_obj 						= {};
			reference_obj.no_referral 				= $("#no_referral").is(':checked');
			reference_obj.name 						= $('#add-reference-name').val();
			reference_obj.relationship 				= $('#add-reference-relationship').val();
			reference_obj.company 					= $('#add-reference-company').val();
			reference_obj.position 					= $('#add-reference-position').val();
			reference_obj.email 					= $('#add-reference-email').val();
			reference_obj.phone 					= $("#add-reference-phone").intlTelInput("getNumber");//$('#add-reference-phone').val();
			reference_obj.phone_basecode			= $("#add-reference-email-div .selected-dial-code").html();
			reference_obj.name 						= reference_obj.name.replace("-","");
			reference_obj.company 					= reference_obj.company.replace("-","");
			reference_obj.position 					= reference_obj.position.replace("-","");
			reference_obj.relationship 				= reference_obj.relationship.replace("-","");


			var internship_obj						= {};
			internship_obj.start_date				= $('#is_start_date').val();
	        internship_obj.end_date 				= $('#is_end_date').val();
	        internship_obj.gd_date					= $('#is_graduation_date').val();

			// Languages
			var languages 							= {};
			languages.language1 					= 'English';
			languages.language_rate1 				= '';
			languages.language2 					= 'Bahasa Malaysia';
			languages.language_rate2 				= '';
			languages.language3 					= 'Chinese';
			languages.language_rate3				= '';
			languages.otherlanguage 				= 'Tamil';
			languages.otherlanguage_rate 			= '';

			$("#language1 .lang-option").each(function (index) {
				if ($(this).hasClass("selected")) {
					var v = $(this).attr('data-value');
					languages.language_rate1 = v;
				}
			});

			$("#language2 .lang-option").each(function (index) {
				if ($(this).hasClass("selected")) {
					var v = $(this).attr('data-value');
					languages.language_rate2 = v;
				}
			});

			$("#language3 .lang-option").each(function (index) {
				if ($(this).hasClass("selected")) {
					var v = $(this).attr('data-value');
					languages.language_rate3 = v;
				}
			});

			$("#otherlanguage .lang-option").each(function (index) {
				if ($(this).hasClass("selected")) {
					var v = $(this).attr('data-value');
					languages.otherlanguage_rate = v;
				}
			});

			// clear Validation - which is not handled by validation class
			$("#photo-error").removeClass('has-error');
			$("#photo-error").find('span').hide();
			$("#lang-error").parents('.form-group').removeClass('has-error');
			$("#lang-error").hide();
			$('#internship-div').find('input').removeClass('important');
			$('#after_nationality').find('.combo-date-picker').removeClass('important');


			var error = 0;

			if (no_photo=='yes')
			{
                sendGaEvent(ACTION_NO_PHOTO_SELECTED, GA_CATEGORY_APPLY_JOB, "");
			}

			if ($('#picture-div').is(':visible')){

				if(isFacebookApp() == false){ // if open using fb browser bypass
					if($('#profile-avatar > .avatar-view').hasClass('active') == false){
						if (no_photo=='no')
						{
							$("#photo-error").addClass('has-error');
							$("#photo-error").find('span').show()
							go('#photo-error',100,800);
							error = 1;
						}
					}
				}else{
					error = 0;
				}
			}


			if ($('#languages-div').is(':visible'))
			{
				if (languages.language_rate1=='' || languages.language_rate2=='' || languages.language_rate3=='' || languages.otherlanguage_rate=='')
				{
					$("#lang-error").parents('.form-group').addClass('has-error');
					$("#lang-error").show();
					go('#languages-div',100,800);
					error = 1;
				}
			}
			else
			languages 							= {};
			if ($('#references-div').is(':visible')) {} else reference_obj = {};
			if ($('#education-div').is(':visible'))  {} else education_obj = {};
			if ($('#location-div').is(':visible')) {} else location_obj = {};
			if ($('#first_time_working-div').is(':visible')) {} else experience_obj = {};
			if ($('#availability-div').is(':visible')) {} else basicprofile_obj.availability = '';
			if ($('#picture-div').is(':visible')) {} else photo = '';
			if ($('#name-div').is(':visible')) {} else name = '';
			if ($('#email-div').is(':visible')) {} else email = '';
			if ($('#phone-div').is(':visible')) {} else phone = '';


			if (error == 1)
			{
				return false;
			}
			else
			{
				console.log(basicprofile_obj);
				$btn.button("loading");
	            $(".applyjob_next").addClass("disabled");
				$("#errors_div").addClass('hide');

				var jsonData = {
					job_id: job_id,
					job_required_data: job_required_data,
					job_filters:jobfilters,
					photo: photo_filename,
					no_photo:no_photo,
					name: name,
					email: email,
					phone: phone,
					selectedDialCode:selectedDialCode,
					languages: languages,
					internship_obj:internship_obj,
					reference_obj:reference_obj,
					basicprofile_obj:basicprofile_obj,
					experience_obj:experience_obj,
					location_obj:location_obj,
					education_obj:education_obj,
					'_token': $('meta[name="csrf-token"]').attr('content'),
					'_method': "POST"
				};

				var request = $.ajax({
					url: canvas_url+'api/job/apply/profiledata',
					data: jsonData,
					type: 'POST',
					crossDomain: true,
					dataType: 'json'
				});

				request.done(function(data) {

					if (data.status=='success')
					{
						$btn.button('reset');
	                    $(".applyjob_next").removeClass("disabled");

						$("#edu_id").val(data.edu_id);
						$("#exp_id").val(data.exp_id);

						$(".div-step1").addClass('hide');
						$(".div-step2").removeClass('hide');
						apply_step = 2;
						go('#applyForm',220,0);
						$('#applyForm').validate().resetForm(); // reset apply form
						$("#tab-step1").removeClass('active');
						$("#tab-step2").addClass('active');
						sendGaEvent(ACTION_FORM_PERSONAL_SUCCESS, GA_CATEGORY_APPLY_JOB, "");
                    }
					else if (data.status=='error3') // Means still some fields are not filled, so give error
					{
						var errors = data.errors;
						var error_types = data.error_types;
						var errors_count = errors.length;
						var error_div = '';
						for (var i =0; i<errors_count;i++)
						{
							error_div += '<li>'+errors[i]+'</li>';
							var error_type_div = error_types[i]+'-div';
							$("#"+error_type_div+" .borderbox").addClass('error');
						}

						$("#errors_list").html(error_div);
						$("#errors_div").removeClass('hide');

						$btn.button('reset');
	                    $(".applyjob_next").removeClass("disabled");
	                    go('#signupForm',220,0);
						//$("body,html").animate({scrollTop: 0}, 800);
						sendGaEvent(ACTION_FORM_PERSONAL_FAILED, GA_CATEGORY_APPLY_JOB, error_div);

						console.log(errors);
					}
				});

				request.fail(function (jqXHR, textStatus) {
					showErrorNotification(jqXHR.status)
					$btn.button('reset');
	                $(".applyjob_next").removeClass("disabled");
				});
			}
		}

		//validation for apply
		$("#applyForm").validate( {
			rules: {
				resume_id: {required : true},
				expected_salary: {
				  required: true,
				  number: true
				},
			},
			messages: {
				'resume_type': txt_nl_selectresume,
				'expected_salary': txt_nl_expectedsalary,
			},
			submitHandler: function() {
				go('.applybtn',100,0);
				$("#applyForm").validate().showErrors({
				  "applybtn": 'Please click "Submit Application" to apply.'
				});
				return false;
			}
		});

		//apply job  button
		$(".applybtn").bind('click', function () {

			if($( "#applyForm").valid() == true){
				$.submitApplyJobApplication();
                $.trackApplication();
			}else{
                $("#applyForm").validate().focusInvalid();;

                var validator = $("#applyForm").validate();
                var missingFields = [];
                $.each(validator.errorMap, function (index, value) {
                    missingFields.push(index);

                    if(godeepCategory){
                        sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, "MISSING_" + index);
                    }
                });

                sendGaEvent(ACTION_APPLY_JOB_MISSING_INFO, GA_CATEGORY_APPLY_JOB, JSON.stringify(missingFields));


			}
			return false;
		});

		$.submitApplyJobApplication = function()
		{
			var job_id 								= $("#job_id").val();
			var pagename 							= $("#pagename").val();
			var $btn 								= $(".apply_submitapplication");
			var job_filters 						= JSON.parse(jobfilters);
			var job_required_data 					= JSON.parse(jobrequireddata);
			var user_object_data					= JSON.parse(userobject);
			var job_data 							= JSON.parse(jobobject);
			var user_data							= user_object_data.user;
			var willing_to_relocate					= $("#willing-to-relocate").val();

			var resume_type 						= $("#resume_type").val();//$('input[name=resume_type]:checked').val();
			var resume_id 							= $("#resume_id").val();
			var resume_check 						= $('input[name=resume_check]:checked').val();
			var newresumefilename 					= $("#newresumefilename").html();
			var resume_title 						= $("#resume_title_new").val();
			var expected_salary_cur 				= $("#expected_salary_cur").val();
			var expected_salary 					= $("#expected_salary").val();
			var cover_letter 						= $("#cover_letter").val();
			var willing_to_relocate					= $("#willing-to-relocate").val();

			var internship_obj						= {};
			internship_obj.start_date				= $('#is_start_date').val();
	        internship_obj.end_date 				= $('#is_end_date').val();
	        internship_obj.gd_date					= $('#is_graduation_date').val();

			var customquestion_obj					= new Array();
			var i = 0;
			var questionidarray						= new Array();
			$(".customquestion").each(function (index) {
				var v = $(this).attr('data-id');
				if (jQuery.inArray(v, questionidarray) !== -1)
				{

				}
				else
				{
					questionidarray.push(v);
					var ans = $('input[name=customquestion'+v+']:checked').val();
					customquestion_obj[i] = v+'-'+ans;
					i++;
				}
			});

			// Validation - which is not handled by validation class
			var error = 0;

			// Resume Validation
			if (resume_type=='existing_resume' && (resume_id=='' || resume_id=='0' || resume_id=='na'))
			{
				$("#resume_id").parent().addClass("error");
				$("#resume_id").focus();
				error = 1;
			}

			if (resume_type=='new_resume' && (newresumefilename=='' || newresumefilename=='0'))
			{
				$("#resumetype_new").prop('checked',false);
				error = 1;
			}

			if (resume_id == 'na' && typeof resume_check == 'undefined') {
				$("#resume_id").parent().addClass("error");
				$("#resume_id").focus();
				error = 1;
			}

			if (typeof resume_check != 'undefined')
			{
				sendGaEvent(ACTION_NO_RESUME_SELECTED, GA_CATEGORY_APPLY_JOB, resume_check);
			}

			if (error==1)
			{
				return false;
			}
			else
			{
				$btn.button("loading");
	            $(".apply_submitapplication").addClass("disabled");
				$("#errors_div").addClass('hide');

				sendGaEvent(ACTION_APPLY_JOB_RESUME, GA_CATEGORY_RESUME, resume_type);

				var jsonData = {
					job_id: job_id,
					job_required_data: job_required_data,
					job_filters:jobfilters,
					willing_to_relocate:willing_to_relocate,
					resume_type: resume_type,
					resume_id: resume_id,
					newresumefilename: newresumefilename,
					resume_check:resume_check,
					resume_title:resume_title,
					expected_salary_cur: expected_salary_cur,
					expected_salary:expected_salary,
					cover_letter: cover_letter,
					willing_to_relocate:willing_to_relocate,
					internship_obj:internship_obj,
					customquestion_obj:customquestion_obj,
					'_token': $('meta[name="csrf-token"]').attr('content'),
					'_method': "POST"
				};

				var request = $.ajax({
					url: canvas_url+'api/job/apply/submitapplication',
					data: jsonData,
					type: 'POST',
					crossDomain: true,
					dataType: 'json'
				});

				request.done(function(data) {

					if (data.status=='success')
					{
						sendGaEvent(ACTION_APPLY_SUCCESS, GA_CATEGORY_APPLY_JOB, "");

                        if(godeepCategory){
                            sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, ACTION_APPLY_SUCCESS);
                        }

                        if(typeof data.applied_id !== 'undefined'){
                            window.location = canvas_url+'job/apply/thanks/' + data.applied_id ;
                        }else{
                            window.location = canvas_url+'job/apply/thanks';
                        }


                        $.trackSuccessApplication();
					}
					else if (data.status=='error4') // Means user has reached the limit of apply job
					{
						$("#capapplyjob-dialog").modal('show');
						console.log('here');
						sendGaEvent(ACTION_APPLY_FAILED, GA_CATEGORY_APPLY_JOB, GA_LABEL_LIMIT_REACHED);

                        if(godeepCategory){
                            sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, GA_LABEL_LIMIT_REACHED);
                        }
						return false;
					}
					else if (data.status=='error3') // Means still some fields are not filled, so give error
					{
						var errors = data.errors;
						var errors_count = errors.length;
						var error_div = '';
						for (var i =0; i<errors_count;i++)
						{
							error_div += '<li>'+errors[i]+'</li>';
						}

						$("#errors_list").html(error_div);
						$("#errors_div").removeClass('hide');


						sendGaEvent(ACTION_APPLY_FAILED, GA_CATEGORY_APPLY_JOB, error_div);

                        if(godeepCategory){
                            sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, ACTION_APPLY_FAILED);
                        }

						$btn.button('reset');
	                    $(".apply_submitapplication").removeClass("disabled");
						$("body,html").animate({scrollTop: 0}, 0);

						console.log(errors);
					}
					else
					{
                        sendGaEvent(ACTION_APPLY_FAILED, GA_CATEGORY_APPLY_JOB, JSON.stringify(data));


                        if(godeepCategory){
                            sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, ACTION_APPLY_FAILED);
                        }


                        $btn.button('reset');
                        $(".apply_submitapplication").removeClass("disabled");
                        showErrorNotification()

                        try{
                            sendErrorEvent(data.status, [ERROR_FINGERPRINT_APPLY_JOB]);
                        }catch(e){

                        }
					}
				});

				request.fail(function (jqXHR, textStatus, errorThrown) {

					sendGaEvent(ACTION_APPLY_FAILED, GA_CATEGORY_APPLY_JOB, GA_LABEL_API_ERROR, jqXHR.status);

                    if(godeepCategory){
                        sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION,ACTION_APPLY_FAILED, GA_LABEL_API_ERROR);
                    }

					$btn.button('reset');
	                $(".apply_submitapplication").removeClass("disabled");
                    showErrorNotification(jqXHR.status)

                    try{
                        var message = jqXHR.status + ": " + jqXHR.statusText + "-" + readyState;
                        sendErrorEvent(errorThrown, [ERROR_FINGERPRINT_APPLY_JOB], message);
                    }catch(e){

                    }
				});
			}
		}

		$(".applyjob_back").bind("click", function () {
			$(".div-step2").addClass('hide');
			$(".div-step1").removeClass('hide');
			apply_step = 1;
			go('#signupForm',220,0);
			$("#tab-step1").addClass('active');
			$("#tab-step2").removeClass('active');
			//$("body,html").animate({scrollTop: 0}, 800);
			// $("#tab-step1").removeClass('bd-white');
			// $("#tab-step2").removeClass('active');
			// $("#tab-step2").removeClass('bd-white');
		});

		$(".applytip").bind("click", function () {
			$("#apply-tip").modal('show');
		});

		$(".resume_deloption").bind("click", function () {
			$("#current_resume").show();
			$("#upload_resume").show();
			$("#success_resume").hide();
			$("#newresumefilename").html('');
			$("#resume_filename_new").val('');
			$("#resume_title_new").val('');
			//$("#resumetype_new").prop("checked",false);
			//$("#newresume").addClass('hide');
			//$("#previewresume").addClass('hide');
		});

		/*$("#profileresume").bind("click", function () {
			$("#success_resume").removeClass('hide');
			$("#newresume").addClass('hide');
			$("#previewresume").removeClass('hide');
			$("#previewresume_link").attr("href",canvas_url+'jobseeker/myresume');
			$("#previewresume_link").attr("target",'_blank');
		});*/

		/*$("#noresume_option").bind("click", function () {
			$("#success_resume").addClass('hide');
			$("#newresume").addClass('hide');
			$("#previewresume").addClass('hide');
		});*/

		/*$("#resumetype_existing").bind("click", function () {
			$("#success_resume").addClass('hide');
			$("#newresume").addClass('hide');
			$("#previewresume").addClass('hide');
		});*/

		$.previewResume = function ()
		{
			$("#noresume-checkbox").hide();
            $("#preview_resume").removeClass('disabled');
			var resume_id = $("#resume_id").val();
			if (resume_id=='profile_resume')
			{
				$("#preview_resume").attr("href",canvas_url+'jobseeker/profile');
				$("#resume_type").val('profileresume');
			}
			else if (resume_id=='na')
			{
				$("#noresume-checkbox").show();
				$("#preview_resume").addClass('disabled');
                $("#preview_resume").attr("href",'#');
                $("#resume_type").val('na');
			}
            else if (resume_id=='upload_resume' || resume_id=='see_all_resume')
            {
                if(resume_id=='see_all_resume'){
                    window.open( canvas_url+"jobseeker/resumes");
                }else{
                    $("#upload-resume").modal();

                    if(godeepCategory){
                        sendGaEvent(godeepCategory, GA_CATEGORY_GODEEP_APPLICATION, GA_LABEL_UPLOAD_RESUME);
                    }

                }
                $("#preview_resume").attr("href",canvas_url+'jobseeker/profile');
                $("#resume_id").val('profile_resume');
            }
			else
			{
				$("#preview_resume").attr("href",canvas_url+'jobseeker/download-resume?id='+resume_id);
				//$("#resume_type").val('resumetype_existing');
				// fix missing attached resume
				$("#resume_type").val('existing_resume');
			}
		}

		$(".applyjob_upload_newresume").bind("click", function () {

	        var resume_title = $("#resume_title_new").val();
	        var resume_filename = $("#resume_filename_new").val();

	        if ($(".upload_newresume").hasClass("disabled")) {
	            return false;
	        } else {

				$("#resume_title-div").removeClass('has-error');
				$("#resume_title-error").addClass('hide');
				$("#resume_file-div").removeClass('has-error');
				$("#resume_file-error").addClass('hide');

				var error = 0;

	            if (resume_title == '') {
	                $("#resume_title-div").addClass('has-error');
					$("#resume_title-error").removeClass('hide');
	                error = 1;
	            }
				if (resume_filename == '') {
	                $("#resume_file-div").addClass('has-error');
					$("#resume_file-error").removeClass('hide');
	                error = 1;
	            }
				if (error==1)
				{
					return false;
				}
				else {
					$("#resume_frame_new").attr("src", canvas_url + "upload_resume_new.php");
	                $("#upload-resume-new").modal('hide');
					$("#upload_resume").hide();
					$('#current_resume').hide();
					$("#success_resume").show();
					$("#newresumefilename").html(resume_filename);
					$("#preview_uploaded_resume").attr("href",canvas_url+'data/tmp/'+resume_filename);
					$("#resume_type").val('new_resume');
					//$("#newresume").removeClass('hide');
					//$("#previewresume").removeClass('hide');
					//$("#newresumefilename").html(resume_filename);
					//$("#previewresume_link").attr("href",canvas_url+'data/tmp/'+resume_filename);
					//$("#previewresume_link").attr("target",'_blank');
	            }
	        }
	    });

		$.setApplyJobFields = function()
		{
			var job_filters 		= JSON.parse(jobfilters);
			var job_required_data 	= JSON.parse(jobrequireddata);
			var user_object_data	= JSON.parse(userobject);
			var job_data 			= JSON.parse(jobobject);
			var user_data			= user_object_data.user;
			var user_skills			= user_object_data.skills;

			// Set User Data - so in case we don't lose any data
			if (user_data.base_country!='0' && user_data.base_country!='' && user_data.base_country!=null)
			{
				$("#base_country").val(user_data.base_country);

				if (user_data.base_country=='Malaysian')
				{
					$("#ic-div").removeClass('hide');
					$("#ic").val(user_data.id_number);
					$("#passport-div").addClass('hide');
				}
				else
				{
					$("#passport").val(user_data.id_number);
					$("#ic-div").addClass('hide');
					$("#passport-div").removeClass('hide');
				}
			}

			if (user_data.gender=='Male')
			$("#genderM").prop("checked",true);
			else if (user_data.gender=='Female')
			$("#genderF").prop("checked",true);

			if (user_data.dob!='0' && user_data.dob!='' && user_data.dob!=null)
			$('#dob').combodate('setValue', user_data.dob, true);

			if (user_data.work_permit!='0' && user_data.work_permit!='' && user_data.work_permit!=null)
			{
				if (user_data.work_permit=='I am Malaysian') user_data.work_permit = 'I am citizen';
				$("#work_permit").val(user_data.work_permit);
			}

			// Address
			$("#address1").val(user_data.address1);
			$("#city").val(user_data.city);
			$("#postal_code").val(user_data.postcode);
			$("#country").val(user_data.country);
			if (user_data.country!='0' && user_data.country!='' && user_data.country!=null)
			{
				ShowStates(user_data.country);
				setTimeout(function () {
						$("#new_state_id").val(user_data.state);
				}, 1000);
			}

			// Languages
			if (user_skills!=null && typeof user_skills!='undefined' && typeof user_skills.sk_language!='undefined' && user_skills.sk_language!=null)
			{
				var userlangs = JSON.parse(user_skills.sk_language);
				var userlangs_count = userlangs.length;
				for (var i=0;i<userlangs_count;i++)
				{
					if (typeof userlangs[i].language1!='undefined')
					{
						var vv = userlangs[i].language_rate1;
						if (parseInt(vv)==0) vv = 5;
						$("#language1 .lang-option").each(function (index) {

							var v = $(this).attr('data-value');
							if (v==vv)  $(this).addClass('selected');
						});
					}

					if (typeof userlangs[i].language2!='undefined')
					{
						var vv = userlangs[i].language_rate2;
						if (parseInt(vv)==0) vv = 5;
						$("#language2 .lang-option").each(function (index) {

							var v = $(this).attr('data-value');
							if (v==vv)  $(this).addClass('selected');
						});
					}

					if (typeof userlangs[i].language3!='undefined')
					{
						var vv = userlangs[i].language_rate3;
						if (parseInt(vv)==0) vv = 5;
						$("#language3 .lang-option").each(function (index) {

							var v = $(this).attr('data-value');
							if (v==vv)  $(this).addClass('selected');
						});
					}

					if (typeof userlangs[i].otherlanguage!='undefined')
					{
						var vv = userlangs[i].otherlanguage_rate;
						if (parseInt(vv)==0) vv = 5;
						$("#otherlanguage .lang-option").each(function (index) {

							var v = $(this).attr('data-value');
							if (v==vv)  $(this).addClass('selected');
						});
					}
				}
			}

			//console.log(job_required_data.length)

			if (job_required_data.length==0) // Nothing required - Jump to Step 2
			{
				$(".div-step1").addClass('hide');
				$(".div-step2").removeClass('hide');
				apply_step = 2;
				$("#tab-step1").removeClass('active');
				$("#tab-step2").addClass('active');
				go('#applyForm',220,0);
				// $("body,html").animate({scrollTop: 0}, 800);
				// $("#tab-step1").addClass('bd-white');
				// $("#tab-step2").addClass('active');
				// $("#tab-step2").addClass('bd-white');
				$(".applyjob_back").parents('.col-sm-6').hide();
				$(".applyjob_back").parents('.col-sm-6').next().addClass('col-sm-offset-3')

			}
			else
			{
				if (jQuery.inArray('name', job_required_data) !== -1)
				{
					$("#name-div").removeClass("hide");
				}

				if (jQuery.inArray('email', job_required_data) !== -1)
				{
					$("#email-div").removeClass("hide");
				}

				if (jQuery.inArray('phone', job_required_data) !== -1)
				{
					$("#phone-div").removeClass("hide");
				}

				if (jQuery.inArray('picture', job_required_data) !== -1)
				{
					$("#picture-div").removeClass("hide");
				}

				if (jQuery.inArray('nationality', job_required_data) !== -1)
				{
					//$("#after_nationality").removeClass('hide');
					$("#nationality-div").removeClass("hide");
				}

				if (jQuery.inArray('dob', job_required_data) !== -1)
				{
					$("#after_nationality").removeClass('hide');
					$("#nationality-div").removeClass("hide");
				}

				if (jQuery.inArray('ic', job_required_data) !== -1)
				{
					$("#after_nationality").removeClass('hide');
					$("#nationality-div").removeClass("hide");
				}

				if (jQuery.inArray('work_permit', job_required_data) !== -1)
				{
					$("#after_nationality").removeClass('hide');
					$("#nationality-div").removeClass("hide");
				}

				if (jQuery.inArray('availability', job_required_data) !== -1)
				{
					$("#availability-div").removeClass("hide");
				}

				if (jQuery.inArray('fresh_graduate', job_required_data) !== -1)
				{
					$("#fresh_graduate-div").removeClass("hide");
				}

				if (jQuery.inArray('first_time_working', job_required_data) !== -1)
				{
					$("#first_time_working-div").removeClass("hide");
				}

				if (jQuery.inArray('location', job_required_data) !== -1)
				{
					$("#location-div").removeClass("hide");
				}

				if (jQuery.inArray('language', job_required_data) !== -1)
				{
					$("#languages-div").removeClass("hide");
				}

				if (jQuery.inArray('education', job_required_data) !== -1)
				{
					$("#education-div").removeClass("hide");
				}

				if (jQuery.inArray('references', job_required_data) !== -1)
				{
					$("#references-div").removeClass("hide");
				}

				if (jQuery.inArray('internship', job_required_data) !== -1)
				{
					$("#internship-div").removeClass("hide");
				}

				if (jQuery.inArray('relocate', job_required_data) !== -1)
				{
					if (user_data.city!='')
					{
						var yourlocation = user_data.city+', '+user_data.state+', '+user_data.postcode;
						$("#relocate-yourlocation").html(yourlocation);

						var worklocation = job_data.city+', '+job_data.state+', '+job_data.postal_code;
						$("#relocate-worklocation").html(worklocation);

						$("#applyjob_distancekm").html(job_filters.distances[0]);
						$("#relocate-confirm").modal('show');
                        $("#applyjob_distancekm").show();
					}
				}
			}
			//console.log(job_required_data);
		}

		$.setApplyJobFields();
	});

}



/**
 * BULK APPLY JOB
 */

$(function () {

	// elements
	var bulkElements = {
		modals  : {
            'confirm': $('#bulk-apply-confirm-modal'),
            'ask': $('#bulk-apply-job-modal'),
            'try': $("#bulkTryModal"),
            'tips': $("#apply-tip"),
        },

		buttons: {
			'confirm' : $('#bulk-apply-confirm-btn'),
			'confirmed' : $('#bulk-apply-confirmed-btn'),
			'go' : $('#bulk-apply-go-btn'),
			'selectAll' : $('#bulk-select-all'),
			'selectNone' : $('#bulk-select-none'),
			'tryBulk' : $('#bulk-try-button'),
			'tooltips' : $('.bulk-apply-tooltips'),
			'tips' : $('.bulk-applytip'),
			'soundTips' : $('.apply-sound-tip'),
		},

		forms: {
			'apply' : $('#_form_bulk_apply_job')
		},

		checkbox: {
			'all' : $('#selectAllApplicants')
		},

		preview: "#bulk-job-preview-",
		count: $('#bulk-apply-count'),
		cookie: 'bulkTryPopup',
		container: '.job-recommendations',
	};

	$(".bulk-select-none").on("click", function(){

    });

    $(".bulk-select-all").on("click", function(){
    	$(this).parent().parent().parent().find("button").attr("disabled", "true");
    });
    
    var _soundPath = canvas_url+"assets/sound/louis";
    var _sound = new buzz.sound(_soundPath, {
        formats: [ "ogg", "mp3", "aac" ]
    });
	// select all
    $('body').on('change', '.applicants-input', function () {
        var checked = $(this).prop('checked');
        $(this).closest('.job-recommendations').find('.applicant-input:checkbox').prop('checked', checked).trigger('change');
    });


    var selectedJobIds = [];
    // update value
    $('body').on('change', '.applicant-input:checkbox', function () {
        selectedJobIds = [];
        var $checkboxes = $(this).closest('.job-recommendations').find('.applicant-input:checkbox');

        $checkboxes.each(function () {
            var checked = $(this).prop('checked');
            var id =  $(this).val();
            var preview = $(bulkElements.preview + id)
            if (checked) {
            	preview.show();
                selectedJobIds.push(id);
                bulkElements.count.html(selectedJobIds.length)

                $(this).parent().parent().parent().find("button").attr("disabled", "true");
            }else{
                preview.hide();
                $(this).parent().parent().parent().find("button").removeAttr("disabled");
			}
        });


        var totalChecked = false;
        if (selectedJobIds.length == $checkboxes.length) {
            totalChecked = true;
        }

        if(selectedJobIds.length > 0){
            bulkElements.buttons.confirm.show();
		}

        if(selectedJobIds.length == 0){
            bulkElements.buttons.confirm.hide();
        }

        $('#count').text(selectedJobIds.length);
        $(this).closest('.job-recommendations').find('.applicants-input').prop('checked', totalChecked);
    });


    // try bulk apply pop up
	bulkElements.buttons.tryBulk.on('click', function () {
        setCookie(bulkElements.cookie,"yes",0.5);
        bulkElements.modals.try.modal('hide');
        go( bulkElements.container,150,500);
        // $('#bulk-apply-tips').tooltip();
        bulkElements.buttons.tooltips.trigger('mouseenter');

    })

    bulkElements.buttons.tooltips.on('show.bs.tooltip', function () {
        if ( $('.bulk-apply-tooltips:hover').length == 0)
        {
            setTimeout(
                function () {
                    bulkElements.buttons.tooltips.tooltip('hide');
                }, 2000);
        }
    });


    // cover letter tips
    bulkElements.buttons.soundTips.on('click', function () {
        _sound.play();
    });

    // stop sound when modal is closed
    bulkElements.modals.tips.on('hidden.bs.modal', function () {
        if(typeof _sound !== 'undefined'){
            _sound.stop();
		}
    })


    bulkElements.buttons.tips.on('click', function () {
            $("#apply-tip").modal('show');
    });

    bulkElements.buttons.confirm.on('click', function () {
		bulkElements.modals.confirm.modal();

    });

    // select all
    bulkElements.buttons.selectAll.on('click', function () {
    	$(this).closest('.job-recommendations').find('.applicant-input:checkbox').prop('checked', true).trigger('change');
    	return false;

    });

    // select none
    bulkElements.buttons.selectNone.on('click', function () {
        bulkElements.checkbox.all.prop('checked', false)
        $(this).closest('.job-recommendations').find('.applicant-input:checkbox').prop('checked', false).trigger('change');
        return false;

    });


    // once user confirmed, ask to fill in expected salary and cover letter
    bulkElements.buttons.confirmed.on('click', function () {
        bulkElements.modals.ask.modal();

    });


    bulkElements.forms.apply.validate( {
        rules: {
            expected_salary: {
                required: true,
                number: true
            },
            cover_letter:{required:false}
        },
        messages: {
            'expected_salary': txt_nl_expectedsalary,
            'cover_letter': txt_nl_whyhireme,
        },

		submitHandler: function() {
            return false;
        }
    });


    // bulk apply job
    bulkElements.buttons.go.on('click', function () {

    	if(bulkElements.forms.apply.valid() == true){
            $.submitBulkApplication($(this));
        }else{
            bulkElements.forms.apply.validate().focusInvalid();;
        }
        return false;

    });


    $.submitBulkApplication = function (element) {

        var $btn = element;

        $btn.button("loading");
        var element = bulkElements.forms.apply;
        var formData = new FormData(element[0]);
        var token = $('meta[name="csrf-token"]').attr('content');
        formData.append('_token', token);

        for (var i = 0; i < selectedJobIds.length; i++) {
            formData.append('jobIDs[]', selectedJobIds[i]);
        }

        var request = $.ajax({
            url: canvas_url + "api/job/apply/bulk",
            data: formData,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            processData: false,
            contentType: false
        });

        request.done(function (data) {
            if (data.success == true) {
                sendGaEvent(ACTION_REGISTER_SUCCESS, GA_CATEGORY_BULK_APPLY, "");
                $btn.button("reset");

                if(typeof data.state !== 'undefined'){
                    window.location = canvas_url+'job/apply/thanks/' + data.state ;
                }else{
                    window.location = canvas_url+'job/apply/thanks';
                }

            }else{
                sendGaEvent(ACTION_REGISTER_FAILED, GA_CATEGORY_BULK_APPLY, data.status);
                $btn.button("reset");
            }
        });

        request.fail(function (jqXHR, textStatus) {
            showErrorNotification(jqXHR.status);
            sendGaEvent(ACTION_REGISTER_FAILED, GA_CATEGORY_BULK_APPLY, textStatus);
            $btn.button("reset");
        });

    }
});

